import { compose } from 'redux';

import { WithCMSSEO } from 'modules/shared-cms/hocs';
import {
    WithFetchDatasByParamsFromCMS,
    WithFetchDatasByParamsFromCMSInputProps,
} from 'modules/shared-cms-advanced/hocs';
import { readCMSValue } from 'modules/shared-cms/utils';
import { WithNotifyRessourceLoaded, WithNotifyRessourceLoadedInputProps } from 'modules/shared/hocs';

import { UniverseProps } from './universe-type';
import { QUERY } from './universe-query';
import { UniverseLoader } from './universe-loader';

const getRessourceName = (data?: UniverseProps): string | undefined => {
    if (data) {
        const { universeTitle } = data;
        return readCMSValue(universeTitle);
    }

    return undefined;
};

const enhancer = compose<
    React.ComponentType<WithFetchDatasByParamsFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByParamsFromCMS<UniverseProps>(UniverseLoader, QUERY, 'queryUniversLandingContents', [
        { filter: 'data/universeId/iv eq $universeId' },
    ]),
    WithNotifyRessourceLoaded(getRessourceName),
    WithCMSSEO(getRessourceName),
);
export default enhancer;
